// Site health #9: accessible names for icon-only social links
const SOCIAL_NETWORKS: [string, string][] = [
  ['instagram.com', 'Instagram'],
  ['twitter.com', 'Twitter'],
  ['x.com', 'X'],
  ['youtube.com', 'YouTube'],
  ['facebook.com', 'Facebook'],
  ['linkedin.com', 'LinkedIn'],
  ['tiktok.com', 'TikTok'],
  ['pinterest.com', 'Pinterest']
];

export default function getSocialLinkLabel(label: string | null | undefined, url: string): string {
  if (label?.trim()) return label.trim();

  try {
    const hostname = new URL(url).hostname.replace(/^www\./, '');
    const network = SOCIAL_NETWORKS.find(([domain]) => hostname === domain || hostname.endsWith(`.${domain}`));
    return network ? network[1] : hostname;
  } catch {
    return 'Social media';
  }
}
